<template>
  <div class="pluginDetail pluginDetailStyle daping-dialog2">
    <el-dialog
      :visible.sync="detailFalse"
      :destroy-on-close="true"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="50%"
    >
      <div class="dialog-title">
        details
        <i class="close-dialog el-icon-close" @click="resetForm()"></i>
      </div>
      <div class="pluginDetail-from">
        <p>
          name：<span>{{ detaCont.name }}</span>
        </p>
        <p>
          type：<span>{{ detaCont.type }}</span>
        </p>
        <p>
          args：<span>{{ detaCont.args }}</span>
        </p>
        <p>
          remark：<span>{{ detaCont.remark }}</span>
        </p>
        <p>
          time：<span>{{ detaCont.time }}</span>
        </p>
        <p>
          subType：<span>{{ detaCont.sub_type }}</span>
        </p>
        <p>
          protocol：<span>{{ detaCont.protocol }}</span>
        </p>
        <p>
          model：<span>{{ detaCont.model }}</span>
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <span class="s1" @click="resetForm('ruleForm')">close</span>
        <!-- <span class="s2" @click="submitForm('ruleForm')">close</span> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'pluginDetail',
  props: {
    detaCont: {
      Type: Object,
      default: {},
    },
  },
  data() {
    return {
      detailFalse: false,
      detaCont: this.detaCont,
    };
  },
  watch: {
    // actiOns: {
    //   handler(val) {
    //     if (val.id != '') {
    //       this.ruleForm = val;
    //       this.ruleForm.name = val.contentMd5;
    //     } else {
    //       this.ruleForm = {};
    //     }
    //   },
    //   jeep: true,
    // },
  },
  mounted() {},
  methods: {
    resetForm(formName) {
      this.detailFalse = false;
      this.$emit('detaCel', true);
    },
  },
};
</script>

<style scoped lang="less">
.pluginDetailStyle {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
  .pluginDetail-from {
    display: flex;
    flex-wrap: wrap;
    padding: 40rem;

    p {
      width: 33%;
      font-size: 17rem;
      line-height: 50rem;
      color: black;
      span {
        font-size: 15rem;
        color: gray;
      }
    }
  }
  .dialog-footer {
    text-align: center;
    .s1 {
      color: #546afc;
      background: #e8efff;
    }
    .s2 {
      color: #e8efff;
      background: #546afc;
    }
    span {
      border-radius: 10rem 10rem;
      width: 100rem;
      height: 45rem;
      text-align: center;
      font-size: 16rem;
      line-height: 45rem;
      display: inline-block;
      cursor: pointer;
      margin: 0 5rem;
      // border-radius: 10%;
    }
  }
}
</style>
